<section *ngIf='show' style="padding: 20px;padding-top: 10px !important;padding-bottom: 0 !important;" class='no0'>
    <div class="col-12">
        <div class="card">
            <div class="card-header no">
                <!-- <h4 style="float: left;">All Attendances : </h4> -->
                <!-- <div style="clear: both;margin-bottom: 5px;"></div> -->
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-3 col-12"></div>
                        <div class="col-lg-3 col-12">
                            <select (change)='permission()' [(ngModel)]='rootSearch' class="form-control mb-2" style="height: 32px !important; width: 100%;border: 1px solid black !important; color: black !important;">
                      <option disabled>Search By Control</option>
                      <option *ngFor='let x of controlA' [value]="x.id">{{x.name}}</option>
              </select>
                        </div>
                        <div class="col-lg-3 col-12">
                            <button *ngIf='add' style="height: 33px;width: 100%;" class="btn btn-success" (click)='addUser()'>Add New Permission</button>
                        </div>
                        <div class="col-lg-3 col-12"></div>
                    </div>
                </div>
                <!-- <div class="container-fluid">
                  <div class="row">
                      <div class="col-lg-3 col-12">
                          <input placeholder="Search By Name" [(ngModel)]='searchName' id='plaho' class="p-1 mb-2" type="text" style="width: 100%; height: 25px;border: 1px solid black !important; color: black !important;">
                      </div>
                      <div class="col-lg-3 col-12"> -->
                <!-- <label>From : </label><br> -->
                <!-- <input *ngIf='OrderDate000S0' (change)='goDate()' id="fromDG" placeholder="Search By Code" class="p-1 mb-2 fromDA" type="date" style="width: 94.5%; height: 32px;border: 1px solid black !important; color: black !important;overflow: hidden;">
                          <input style="height: 20px;border: 1px black solid !important; color: black !important;" *ngIf='OrderDate000S' (mouseenter)='OrderDate0010S()' class="text d1 mb-2" type="text" placeholder="From Date" required="">
                      </div>
                      <div class="col-lg-3 col-12"> -->
                <!-- <label>To : </label><br> -->
                <!-- <input *ngIf='OrderDate000SS0' (change)='goDate()' id="toDG" placeholder="Search By Code" class="p-1 mb-2 toDA" type="date" style="width: 94.5%; height: 32px;border: 1px solid black !important; color: black !important;overflow: hidden;">
                          <input style="height: 20px;border: 1px black solid !important; color: black !important;" *ngIf='OrderDate000SS' (mouseenter)='OrderDate0010SS()' class="text d1 mb-2" type="text" placeholder="To Date" required="">
                      </div> -->
                <!-- <div class="col-lg-3 col-12">
                          <select [(ngModel)]='rootSearch' class="form-control mb-2" style="height: 32px !important; width: 100%;border: 1px solid black !important; color: black !important;">
                        <option disabled>Search By Root</option>
                        <option>All</option>
                        <option *ngFor='let x of rootA' [value]="x.id">{{x.name}}</option>
                </select>
                      </div> -->
                <!-- <div class="col-lg-3 col-12">
                          <select [(ngModel)]='controlSearch' class="form-control mb-2" style="height: 32px !important;width: 100%;border: 1px solid black !important; color: black !important;line-height: 0;">
                        <option disabled>Search By Permission</option>
                        <option>All</option>
                        <option *ngFor='let r of controlA' [value]="r.id">{{r.name}}</option>
                      </select>
                      </div> -->
                <!-- <div class="col-lg-2 col-12">
                          <button (click)='addUser()' style="height: 32px !important; width: 94.5% !important;border: 1px solid black !important;line-height: 0; " type="button" class="btn btn-secondary mb-2">Add Attendance</button>
                      </div>
                      <div class='col-lg-1 col-12'>
                          <button (click)='printert()' class="btn btn-secondary" style="height: 32px !important;border: 1px solid black !important;width: 94.5% !important;line-height: 0;"><i class="fas fa-print"></i></button>
                      </div>
                  </div>
              </div> -->
            </div>





            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 67.2vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;">
                        <table id='calltable' class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style="text-align: center;">#</th>
                                    <th scope="col">Module_Name</th>
                                    <th scope="col">Add</th>
                                    <th scope="col">Edit</th>
                                    <th scope="col">Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of rootA|samedate:dateFrom:dateTo|searchEmployee:searchName; let n = index;'>
                                    <th scope="row" style="text-align: center;"><input (click)='checkout(n)' (change)='addUser0(v.id , n)' style="cursor: pointer;" type="checkbox" name="Accept{{n}}" id="Accept{{n}}" value="1"></th>
                                    <td data-title="Module_Name">{{v.name}}</td>
                                    <td data-title="Add"><input (change)='addUser0(v.id , n)' style="cursor: pointer;" type="checkbox" name="Add{{n}}" id="Add{{n}}" value="1" disabled></td>
                                    <td data-title="Edit"><input (change)='addUser0(v.id , n)' style="cursor: pointer;" type="checkbox" name="Edit{{n}}" id="Edit{{n}}" value="1" disabled></td>
                                    <td data-title="Delete"><input (change)='addUser0(v.id , n)' style="cursor: pointer;" type="checkbox" name="Delete{{n}}" id="Delete{{n}}" value="1" disabled></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>















        </div>
    </div>
    <section id="upd">
        <div class="main-w3layouts wrapper" style="z-index: 1;">
            <div class="main-agileinfo">
                <i (click)='close()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
                <div class="agileits-top">
                    <form #data='ngForm' (submit)='addUser00(data.value)' style="direction: ltr !important;">
                        <span id="form00" style="display: block;">
            <label style="color: white;" class="mt-2">Name : </label>
            <input style="height: 25px;"  class="text mt-2 d1 UpCha" type="text" name="name" [(ngModel)]='name' placeholder="Name" required="">
              <input style="margin-top: 1rem !important;width: 94.5% !important;float: left; padding: 5px !important;" type="submit" value="Add">
              <div style="clear: both;"></div>
              </span>
                    </form>
                </div>
            </div>
        </div>
    </section>

</section>
<section class="loading">
    <div class="spinner">
        <div class="sk-circle">
            <div class="sk-circle1 sk-child"></div>
            <div class="sk-circle2 sk-child"></div>
            <div class="sk-circle3 sk-child"></div>
            <div class="sk-circle4 sk-child"></div>
            <div class="sk-circle5 sk-child"></div>
            <div class="sk-circle6 sk-child"></div>
            <div class="sk-circle7 sk-child"></div>
            <div class="sk-circle8 sk-child"></div>
            <div class="sk-circle9 sk-child"></div>
            <div class="sk-circle10 sk-child"></div>
            <div class="sk-circle11 sk-child"></div>
            <div class="sk-circle12 sk-child"></div>
        </div>
    </div>
</section>
<section id="upd-dd">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closedd()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <span id="form00" style="display: block;">
          <input (click)='ok()' style="margin-top: 1rem !important;width: 94.5% !important;float: left;padding: 5px  !important;" type="submit" value="Are You Sure ?">
          <div style="clear: both;"></div>
          </span>
            </div>
        </div>
    </div>
</section>
<section id="upd-up">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closeUp()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <form #data='ngForm' (submit)='okUp(data.value)' style="direction: ltr !important;">
                    <span id="form00" style="display: block;">
                  <label style="color: white;">Name : </label>
                <input style="height: 25px;" class="text mt-2 d1" type="text" name="nameU" [(ngModel)]='nameU' placeholder="Name" required="">
                <label style="color: white;" class="mt-2">E-mail : </label>
                <input style="height: 25px;"  class="text mt-2 d1" type="text" name="emailU" [(ngModel)]='emailU' placeholder="Email" required="">
                <label style="color: white;" class="mt-2">Adress : </label>
                <input style="height: 25px;" class="text mt-2 d1" type="text" name="adressU" [(ngModel)]='adressU' placeholder="Adress" required="">
                <label style="color: white;" class="mt-2">Branch : </label>
                <select [(ngModel)]='rootU' name="rootU" class="form-control mt-4 select2 rootSelectU" style="height: unset !important;">
                  <option [value]='rootU' disabled>Branch</option>
                  <option *ngFor='let x of rootA' [value]="x.id">{{x.name}}</option>
          </select>
          <label style="color: white;" class="mt-2">Password : </label>
                <input style="height: 25px;" class="text mt-2 d1" type="password" name="passwordU" [(ngModel)]='passwordU' placeholder="Password" required="">
                <label style="color: white;" class="mt-2">Phone : </label>
                <input style="height: 25px;" class="text mt-2 d1" type="number" name="phoneU" [(ngModel)]='phoneU' placeholder="Phone" required="">
                <label style="color: white;" class="mt-2">Permission : </label>
<select [(ngModel)]='controlU' name="controlU" class="form-control mt-4 select2 controlSelectU" style="height: unset !important;">
  <option [value]='controlU' disabled>Permission</option>
  <option *ngFor='let r of controlA' [value]="r.id">{{r.name}}</option>
</select>
                  <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;padding: 5px  !important;" type="submit" value="Update">
                  <div style="clear: both;"></div>
            </span>
                </form>
            </div>
        </div>
    </div>
</section>